/**
 * Defaults para Botones
 */

export const buttonDefaults: Record<string, Record<string, unknown> | undefined> = {
  VBtn: {
    style: [{ textTransform: 'none' }],
    rounded: 'lg',
    variant: 'elevated',
  },

  VBtnPrimary: {
    color: 'primary',
    variant: 'elevated',
    rounded: 'lg',
  },

  VBtnSecondary: {
    color: 'accent',
    variant: 'outlined',
    rounded: 'lg',
  },

  VBtnTertiary: {
    color: 'gray-600',
    variant: 'text',
    rounded: 'lg',
  },

  VBtnSuccess: {
    color: 'success',
    variant: 'elevated',
    rounded: 'lg',
  },

  VBtnDanger: {
    color: 'error',
    variant: 'elevated',
    rounded: 'lg',
  },

  VBtnWarning: {
    color: 'warning',
    variant: 'elevated',
    rounded: 'lg',
  },

  VBtnInfo: {
    color: 'info',
    variant: 'elevated',
    rounded: 'lg',
  },
}
